import React, { memo } from 'react';
import { StructuredList as StructuredListType } from '../../Dto/chatbotStructuredResponse';
import './StructuredComponents.css';

interface StructuredListProps {
  list: StructuredListType;
  isMobile?: boolean;
}

const StructuredList: React.FC<StructuredListProps> = ({ list, isMobile = false }) => {
  if (!list || !list.items || list.items.length === 0) {
    return null;
  }

  return (
    <div className={`chatbot-structured-list-container ${isMobile ? 'mobile' : ''}`}>
      {list.title && (
        <h4 className="chatbot-list-title">{list.title}</h4>
      )}
      <ul className="chatbot-structured-list">
        {list.items.map((item, index) => (
          <li key={index} className="chatbot-list-item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(StructuredList);
